import * as React from 'react';
import { useState } from 'react';

import './core-carousel.css'
/*
EXAMPLE

<div style={{
				width: '1500px',
				height: '500px',
				position: 'absolute',
				left: '300px',
				top: '300px'
			}}>
				<CoreCarousel cardsPerView={3} cards={[
					{
						img: process.env.PUBLIC_URL + '/assets/sample.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample2.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample3.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample4.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample5.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample6.jpg'
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample7.jpg'
					}
				]}></CoreCarousel>
			</div>


*/

const CoreCarousel = (props: CoreCarouselConfig) => {
	const [currentPage, setCurrentPage] = useState(0);

	const onBackClicked = () => {
		setCurrentPage(currentPage-1);
	}

	const onNextClicked = () => {
		setCurrentPage(currentPage+1);
	}
	return (
		<div className='core-carousel-container'>
			{currentPage-1 >= 0 ? <div className='core-carousel-container-back-container' onClick={onBackClicked}>
				<div className='core-carousel-container-back core-carousel-container-arrow'></div>
			</div> : (null)}
			<div className='core-carousel-container-content' style={{
				gridTemplateColumns: (() => {
					let result = '';
					for(var indx = 0 ; indx < props.cardsPerView; indx++) {
						result += (100 / props.cardsPerView) + '%';
					}
					return result;
				})()
			}}>
				{props.cards.map((card: CoreSingleCardConfig, indx: number) => {
					const startPoint = currentPage * props.cardsPerView;
					const endPoint = startPoint + props.cardsPerView;
					if(indx >= startPoint && indx < endPoint) {
						return (
							<div className='core-carousel-container-single-card'>
								<img src={card.img} />
							</div>
						);
					} else {
						return null;
					}
				})}
			</div>
			{(currentPage + 1) * props.cardsPerView < props.cards.length ? <div className='core-carousel-container-next-container' onClick={onNextClicked}>
				<div className='core-carousel-container-next core-carousel-container-arrow'></div>
			</div> : (null)}
		</div>
	);
}

export default CoreCarousel;

export class CoreCarouselConfig {
	cardsPerView: number;
	cards: CoreSingleCardConfig[];
}

export class CoreSingleCardConfig {
	img: string;
}